// extracted by mini-css-extract-plugin
module.exports = {"bm-section":"bm-section"};